module.exports = __webpack_public_path__ + "static/media/2ndSlide.8404def8.mp3";